// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountBalanceCheckRequestStatus {
  ToBeProcessed = "TO_BE_PROCESSED",
  Processed = "PROCESSED",
  ProcessingFailed = "PROCESSING_FAILED",
}
export default AccountBalanceCheckRequestStatus;
